var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"tsa-environmentCheck"},[_c('div',{staticClass:"mask"}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("./images/wuhen.png"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f6dfd1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/environmentCheck/index.vue
// module id = null
// module chunks = 